import React from 'react'
import Navbar  from './component/Navbar'
import { Routes, Route} from 'react-router-dom'
import Hero from './component/Hero'

import About from './component/About'
import Project from './component/Project'
import Photography from './component/Photography'
import Contact from './component/Contact'

import Footer from './component/Footer'
import Technology from './component/Technology'
import Slider from './component/Slider'
import Home from './routes/Home'
import AboutRoute from './routes/AboutRoute'
import ProjectRoute from './routes/ProjectRoute'
import ContactRoute from './routes/ContactRoute'
import TechRoute from './routes/TechRoute'
const App = () => {
  return (
   <>
   
   
   
   
   <Routes>
    
    <Route path='/' element={<Home/>}/>
    <Route path='/about' element={<AboutRoute/>}/>
    <Route path='/technology' element={<TechRoute/>}/>
    <Route path='/project' element={<ProjectRoute/>}/>
    <Route path='/contact' element={<ContactRoute/>}/>
    
    </Routes>    
    
    
  
   </>
  )
}

export default App